export default "__VITE_ASSET__KCGyt1yH__"